import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface CheckListPdfDialogData {
  exists: boolean;
  downloadUrl?: string;
  pdfName?: string;
  async?: boolean;
  imageCount?: number;
  estimatedTime?: string;
  message?: string;
}

@Component({
  selector: 'app-check-list-pdf-dialog',
  templateUrl: './check-list-pdf-dialog.component.html',
  styleUrls: ['./check-list-pdf-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CheckListPdfDialogComponent {
  private dialogRef = inject(MatDialogRef<CheckListPdfDialogComponent>);
  data = inject<CheckListPdfDialogData>(MAT_DIALOG_DATA);

  onDownloadExisting(): void {
    if (this.data.downloadUrl) {
      window.open(this.data.downloadUrl, '_blank');
    }
    this.dialogRef.close();
  }

  onGenerateNew(): void {
    this.dialogRef.close({ regenerate: true });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
